<template>
  <div class="status_1_content_Indexes" :class="{ showClass: showStatus  }">
    <div class="header">
      步 骤
    </div>
    <ul>
      <li
        v-for="(item, index) in currentValue"
        @click="liClick(item,index)"
        :key="index"
        :class="activeIndex==index?'active':''"
        :title="item.extendOption.indexText"
      >
        {{item.extendOption.indexText}}
      </li>
      <div class="line" ref="line"></div>
    </ul>
  </div>
</template>

<script>
  import bus from '@/bus/bus'
    export default {
        name: "status_1_content_Indexes",
        props: {
          value: {
            type: Object,
            default: () => {},
          },
          isShow:{
            type:Boolean,
            default:false,
          }
        },
      data(){
          return {
            currentValue:[],
            activeIndex: 0,
            showStatus: false,
          }
      },
      watch: {
        value: {
          handler() {
            this.init();
          },
          immediate: true,
          deep: true,
        },
      },
      methods:{
        init(){
          this.currentValue = [];
          let imageText;
          if (this.value.imageText){
            if (typeof this.value.imageText === "object"){
              imageText = this.value.imageText;
            }else{
              imageText = JSON.parse(this.value.imageText);
            }
          }

          if(imageText && imageText.length){
            [].forEach.call(imageText, item =>{
              try{
                if (item.extendOption && item.extendOption.isIndexes){
                  this.currentValue.push(item)
                  // console.log('item',item)
                }
              }catch(err){}
            })
          }
          if (this.currentValue.length>0) {
            this.showStatus = true;
          }else{
            this.showStatus = false;
          }

        },
        // tabClick(o){
        //   bus.$emit('goIndexes',this.currentValue[o.index] );

        // },
        liClick(item,index){
          this.activeIndex = index
          this.$refs.line.animate([
            { top:  this.$refs.line.style.top + 'px'},
            { top:  index*40+'px'}
          ], {
              duration: 300,
              easing: 'ease-in-out',
              iterations: 1,
              fill: 'forwards'
          });
          bus.$emit('goIndexes',this.currentValue[index] );
        }
      }
    }
</script>

<style scoped lang="scss">
.status_1_content_Indexes{
  padding: 0;
  user-select: none;
  width: 0px;
  overflow: hidden;
  margin-top: 40px;
  line-height: 20px;
  transition: all 0.3s ease-out;
  .header{
    margin-bottom: 25px;
    padding-left: 20px;
    text-align: left;
    padding-right: 56px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #0F0D11;
  }
  ul{
    position: relative;
    display: flex;
    flex-direction: column;
    li{
      padding: 0 20px;
      height: 40px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      line-height: 40px;
      display: inline-block;
      list-style: none;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      position: relative;
      cursor: pointer;
      border-left: 2px solid #eee;
      overflow: hidden;    //超出部分隐藏
      white-space: nowrap;    //不换行
      text-overflow:ellipsis;     //文字超出部分用省略号表示
    }
    .active{
        color: #409EFF;
        // border-left: 2px solid #409EFF;
      }
    .line{
      position:absolute;
      height: 40px;
      width: 2px;
      top: 0px;
      left: 0px;
      background: #409EFF;
    }
  }
}

  .showClass{
    width: 200px;
    padding-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/new_learning_module/components/status_1_content_Indexes.vue